import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/akm.png'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "CDMS账号管理系统", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_menu = _resolveComponent("base-menu")!
  const _component_right_content = _resolveComponent("right-content")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classNames)
  }, [
    _createElementVNode("div", {
      ref: "headRef",
      class: _normalizeClass(_ctx.headerClassName)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(`${_ctx.prefixedClassName}-main-left`),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMenuHeaderClick && _ctx.handleMenuHeaderClick(...args)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`${_ctx.prefixedClassName}-logo`),
          key: "logo",
          id: "logo"
        }, [
          (_ctx.hasLogoSlot)
            ? _renderSlot(_ctx.$slots, "logo", { key: 0 })
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_link, { to: { name: 'index' } }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]))
        ], 2)
      ], 2),
      _createElementVNode("div", {
        style: { flex: 1 },
        class: _normalizeClass(`${_ctx.prefixedClassName}-menu`)
      }, [
        (_ctx.menus && _ctx.menus.length > 0)
          ? (_openBlock(), _createBlock(_component_base_menu, {
              key: 0,
              mode: "horizontal",
              theme: _ctx.theme,
              menus: _ctx.menus,
              "open-keys": _ctx.openKeys,
              "selected-keys": _ctx.selectedKeys,
              "onUpdate:openKeys": _ctx.handleOpenKeys,
              "onUpdate:selectedKeys": _ctx.handleSelectedKeys
            }, null, 8, ["theme", "menus", "open-keys", "selected-keys", "onUpdate:openKeys", "onUpdate:selectedKeys"]))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_right_content, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "rightContent")
        ]),
        _: 3
      })
    ], 2)
  ], 2))
}